import script from "./CartProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartProduct.vue?vue&type=script&lang=ts&setup=true"

import "./CartProduct.vue?vue&type=style&index=0&id=1b528a61&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b528a61"]])

export default __exports__